//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoRatingBasic from './demos/DemoRatingBasic.vue'
import DemoRatingDense from './demos/DemoRatingDense.vue'
import DemoRatingColors from './demos/DemoRatingColors.vue'
import DemoRatingSize from './demos/DemoRatingSize.vue'
import DemoRatingLength from './demos/DemoRatingLength.vue'
import DemoRatingHover from './demos/DemoRatingHover.vue'
import DemoRatingReadonly from './demos/DemoRatingReadonly.vue'
import DemoRatingClearable from './demos/DemoRatingClearable.vue'
import DemoRatingIncremented from './demos/DemoRatingIncremented.vue'
import DemoRatingItemSlot from './demos/DemoRatingItemSlot.vue'

// code
import {
  ratingBasic,
  ratingDense,
  ratingColors,
  ratingSize,
  ratingLength,
  ratingHover,
  ratingReadonly,
  ratingClearable,
  ratingIncremented,
  ratingItemSlot,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoRatingBasic,
    DemoRatingDense,
    DemoRatingColors,
    DemoRatingSize,
    DemoRatingLength,
    DemoRatingHover,
    DemoRatingReadonly,
    DemoRatingClearable,
    DemoRatingIncremented,
    DemoRatingItemSlot,
  },
  setup() {
    return {
      codeSnippets: {
        ratingBasic,
        ratingDense,
        ratingColors,
        ratingSize,
        ratingLength,
        ratingHover,
        ratingReadonly,
        ratingClearable,
        ratingIncremented,
        ratingItemSlot,
      },
    }
  },
}
